
<script>
export default {
  name: "MapPolygon",
  props: ["points", "map"],
  mounted() {
    if (this.points) {
      this.drawPolygon(this.points);
    }
  },
  methods: {
    drawPolygon(boundary, index) {
      const points = boundary.polygonPointsWgs84.map((point) => {
        return {
          lat: point.X,
          lng: point.Y,
        };
      });

      let boundaryPolygon;
      if (boundary.adHocPolygonTypeCode === "D") {
        boundaryPolygon = new google.maps.Polygon({
          paths: points,
          strokeColor: "#FBB814",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#FBB814",
          fillOpacity: 0.5,
          zIndex: 2,
          group: boundary.adHocPolygonTypeCode,
          location: boundary,
          visible: boundary.selected,
        });
      }
      if (boundary.adHocPolygonTypeCode === "E") {
        boundaryPolygon = new google.maps.Polygon({
          paths: points,
          strokeColor: "#30505E",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#30505E",
          fillOpacity: 0.5,
          zIndex: 2,
          group: boundary.adHocPolygonTypeCode,
          location: boundary,
          visible: boundary.selected,
        });
      }
      if (boundary.adHocPolygonTypeCode === "G") {
        boundaryPolygon = new google.maps.Polygon({
          paths: points,
          strokeColor: "#EE5200",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#EE5200",
          fillOpacity: 0.5,
          zIndex: 2,
          group: boundary.adHocPolygonTypeCode,
          location: boundary,
          visible: boundary.selected,
        });
      }

      if (boundary.adHocPolygonTypeCode === "H") {
        boundaryPolygon = new google.maps.Polygon({
          paths: points,
          strokeColor: "#009DD2",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#009DD2",
          fillOpacity: 0.5,
          zIndex: 2,
          group: boundary.adHocPolygonTypeCode,
          location: boundary,
          visible: boundary.selected,
        });
      }

      boundaryPolygon.addListener("click", () => {
        this.$emit("handlePolygonClick", boundaryPolygon);
      });
      boundaryPolygon.setMap(this.map);
      this.$emit("polygonCreated", boundaryPolygon);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapPolygon.vue